import { prop } from 'ramda';
import { createSelector } from 'reselect';
import { getCoreApi } from './coreApi';

export const getMissionMonitoring = createSelector(getCoreApi, prop('missionMonitoring'));
export const getEventSource = createSelector(getMissionMonitoring, prop('eventSource'));
export const getEta = createSelector(getMissionMonitoring, ({ eta } = {}) => (eta && new Date(eta)) || null);
export const getStatus = createSelector(getMissionMonitoring, prop('status'));
export const getLocation = createSelector(getMissionMonitoring, prop('currentLocation'));
export const getService = createSelector(getMissionMonitoring, prop('service'));
